<template>
<!-- $route.name === 'productdetails' || -->
  <div :style="[bannerStyle]" id="exclusive-savings-info" class="exclusive-topbar" :class="isExclusiveSavingVisible ? 'd-block' : 'd-none'" v-if="$route.name === 'listing'">
    <div class="container-fluid p-0">
      <div class="row" v-if="bannerMsg">
        <div class="col-md-12 text-center ml-1 mr-1 pt-1 pb-1">
          <span>
            <span>{{bannerMsg}} <strong v-if="calculations.exclusive_savings && bannerMsg.includes('Rs')">{{parseInt(calculations.total_savings - calculations.coupon_discount)}}</strong></span>
          </span>
          <button type="button" @click="closeInfoBar" class="close" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  var $ = require('jquery')
  window.jQuery = $
  export default {
    name: 'ExclusiveSavingsInfo',
    props: ['isExclusive', 'calculations', 'bannerStyle', 'bannerMsg'],
    data () {
      return {
        isExclusiveSavingVisible: false
      }
    },
    methods: {
      closeInfoBar () {
        let $exclusiveBar = $('#exclusive-savings-info')
        $exclusiveBar.slideUp()
        this.isExclusiveSavingVisible = false
        this.$store.commit('GTAG_EVENT', {eventName: 'cstm.ga.exclusive.popup.closed', payload: {}})
      },
      toggleExclusiveBar () {
        let $exclusiveBar = $('#exclusive-savings-info')
        if (this.calculations.exclusive_savings > 0 && this.isExclusive) {
          this.$store.commit('GTAG_EVENT', {eventName: 'cstm.ga.exclusive.popup.open', payload: {}})
          this.$store.commit('GTAG_EVENT', {eventName: 'exclusive_membership_banner', payload: {}})
          this.isExclusiveSavingVisible = true
          $exclusiveBar.slideDown()
          // hide this bar after 10 sec
          setTimeout(() => {
            this.isExclusiveSavingVisible = false
            $exclusiveBar.slideUp()
          }, 1000 * 10)
        } else {
          this.isExclusiveSavingVisible = false
          $exclusiveBar.slideUp()
        }
      },
      continueShopping () {
        this.$router.push('/')
      }
    },
    mounted: function () {
      this.toggleExclusiveBar()
    },
    watch: {
      // calculations: function (val) {
      //   this.toggleExclusiveBar()
      // },
      // $route (to, from) {
      //   console.log(to.name)
      //   if (to.name) {
      //     this.toggleExclusiveBar()
      //   }
      // }
    }
  }
</script>

<style scoped>
  #exclusive-savings-info {
    padding: 3px 0;
    font-size: 20px;
    letter-spacing: 2px;
    position: sticky;
    top: 42px;
    z-index: 99;
  }

  .exclusive-topbar .close {
    color: #cb5057;
    text-shadow: none;
    font-size: 30px;
    margin-right: 0.75rem;
  }

  @media screen and (min-width: 991px) {
    #exclusive-savings-info {
      top: 58px;
    }
  }

  @media screen and (max-width: 415px) {
     #exclusive-savings-info {
      font-size: 14px;
    }

     #exclusive-savings-info .close {
      font-size: 24px;
      line-height: 0.8;
      margin-right: 0.25rem;
    }
  }
</style>



// WEBPACK FOOTER //
// ExclusiveSavingInfo.vue?aed094a4